module.exports = __webpack_public_path__ + "static/media/order_placed_illustration.03c0905b.svg";